import { Board } from '../lib/wordboard';
import { BoardWord } from '../lib/vowelboard';
import { FindPatternGameData } from './findpatterngame';

export const TutorialWordList = ["forward", "reverse", "upward", "down", "diagonal"]

export function createTutorialData(): FindPatternGameData {
    var board:Board = {
        Cols: 5,
        Rows: 5,
        Letters: [
        //    0   1   2   3   4
            ['f','r','w','r','d'], // 0
            ['d','s','q','g','r'], // 1
            ['w','h','n','v','w'], // 2
            ['n','l','z','x','p'], // 3
            ['s','r','v','r','m'], // 4
        ],
        Words: [
            { Direction: "right", Position: { Col: 0, Row: 0}, Word: "frwrd" } as BoardWord,
            { Direction: "left", Position: { Col: 3, Row: 4}, Word: "rvrs" } as BoardWord,
            { Direction: "up", Position: { Col: 4, Row: 3}, Word: "pwrd" } as BoardWord,
            { Direction: "down", Position: { Col: 0, Row: 1}, Word: "dwn" } as BoardWord,
            { Direction: "leftDown", Position: { Col: 4, Row: 0}, Word: "dgnl" } as BoardWord,
        ]
    }
    
    var wordlist = TutorialWordList;
    var patternlist = wordlist.map(w => w.replace(/[^aeiou]/g,' '));

    console.log("wordlist: ", wordlist)
    return { 
        removeLetters: true,
        board: board,
        patternList: patternlist,
        currentPatternIdx: 0,
        foundWords: [],
    }
}
